module.exports = __webpack_public_path__ + "static/img/weChats.2841ca0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weChats.jpeg
// module id = lYg+
// module chunks = 1